'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _isFinite = require('babel-runtime/core-js/number/is-finite');

var _isFinite2 = _interopRequireDefault(_isFinite);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Base64Deriver = function () {
  function Base64Deriver() {
    (0, _classCallCheck3.default)(this, Base64Deriver);
  }

  (0, _createClass3.default)(Base64Deriver, null, [{
    key: 'decodeNumber',
    value: function decodeNumber(data) {
      if (typeof data !== 'string') {
        return;
      }

      var decoded = void 0;

      /* istanbul ignore else */
      if (__SERVER__) {
        decoded = Buffer.from(data, 'base64').toString('ascii');
      } else {
        decoded = atob(data);
      }

      if (/^\d+$/.test(decoded)) {
        return parseInt(decoded, 10);
      }
    }
  }, {
    key: 'encode',
    value: function encode(data) {
      // Only non-extended ASCII is supported for strings, across node/browser.
      var isValidString = typeof data === 'string' && /^[\x00-\x7F]*$/.test(data); // eslint-disable-line no-control-regex
      // NaN, +Infinity and -Infinity are type 'number' as well, we want to ignore those to avoid surprises.
      var isValidNumber = typeof data === 'number' && (0, _isFinite2.default)(data);

      if (!(isValidString || isValidNumber)) {
        return;
      }

      var encoded = void 0;

      /* istanbul ignore else */
      if (__SERVER__) {
        encoded = Buffer.from(String(data)).toString('base64');
      } else {
        encoded = btoa(data);
      }

      return encoded;
    }
  }]);
  return Base64Deriver;
}();

exports.default = Base64Deriver;